export const productImage =
  'https://cdn.magicpatterns.com/uploads/aSYNJzAPaCP5JwVWTfuPJk/ChatGPT_Image_8_ago_2026,_06_50_11_p.m..png'

export const checkoutUrl = 'https://pickleball-coach-pro.impultienda.ar/checkout'

export const pains = [
  {
    emoji: '😰',
    title: 'Planning Takes Too Much Time...',
    lines: [
      'What should I teach today?',
      'Which drill should I use?',
      'How should I progress it?',
      'What should this player work on next?',
      'How do I adapt the session for different levels?',
      'Instead of having everything ready...',
      'You spend hours searching, organizing, modifying, and rebuilding sessions from scratch.',
    ],
  },
  {
    emoji: '⚠️',
    title: 'Always Searching For Better Drills',
    lines: [
      'Serves. Returns. Dinks. Drops. Drives. Volleys. Resets. Transition play. Kitchen control. Doubles tactics.',
      'Hundreds of drills exist online.',
      "But they're scattered across videos, websites, social media, and saved notes.",
      'Finding a drill is easy.',
      'Finding the right drill, progression, coaching focus, and next step is the real challenge.',
    ],
  },
  {
    emoji: '🏓',
    title: 'No Clear Player Development Process',
    lines: [
      "A good session isn't enough.",
      'Players need progression.',
      'What should come first? What comes next?',
      'When should difficulty increase?',
      'When should technical work become tactical?',
      'When is a player ready to progress?',
      'Without a structured development system...',
      'Sessions can quickly become disconnected instead of building toward measurable improvement.',
    ],
  },
  {
    emoji: '😩',
    title: 'Managing Different Players Gets Complicated',
    lines: [
      'One player needs better drops.',
      'Another struggles at the kitchen.',
      'Another needs transition work.',
      'Your doubles team needs better positioning.',
      'Your group has different ability levels.',
      'Your competitive player needs match preparation.',
      "Knowing pickleball isn't the problem.",
      'Having the right material ready for every coaching situation is.',
    ],
  },
]

export const solutionPoints = [
  'Plan faster.',
  'Coach with confidence.',
  'Build clear player progressions.',
  'Deliver structured sessions.',
  'Develop players consistently.',
]

export const modules = [
  {
    title: 'Pickleball Skill Development System™',
    description:
      'Develop the technical and tactical skills players need on court. Work with serves, returns, dinks, drops, drives, volleys, resets, transition play, footwork, positioning, defense, attack, shot selection, and doubles decisions using structured coaching cues, corrections, and level-based progressions.',
  },
  {
    title: 'Pickleball Drill Library™',
    description:
      'Access ready-to-use drills for technical, tactical, and competitive development. Each drill includes a clear objective, setup, execution, coaching focus, progression, regression, and adaptation options so you can quickly select the right activity for different players, levels, and training goals.',
  },
  {
    title: 'Pickleball Session Planner™',
    description:
      'Build professional sessions without starting from scratch. Use structured frameworks for private lessons, pairs, groups, clinics, technical training, tactical training, and competitive sessions. Organize warm-ups, skill development, drills, game application, and reviews around clear coaching objectives.',
  },
  {
    title: 'Ready-to-Coach Pickleball Sessions™',
    description:
      'Take complete sessions directly to the court. Access structured training for beginner, intermediate, and advanced players covering serve and return, kitchen play, transition skills, attack, defense, doubles tactics, and match preparation with objectives, timing, drills, progressions, and coaching points.',
  },
  {
    title: 'Player Development Programs™',
    description:
      'Turn individual sessions into structured development pathways. Use progressive multi-week programs for different player levels and goals, with training priorities, skill progressions, tactical development, checkpoints, and clear criteria that help determine what each player should work on next.',
  },
  {
    title: 'Pickleball Coach Toolkit™',
    description:
      'Manage player development professionally with assessments, skill checklists, player profiles, goal-setting tools, session records, progress trackers, match observation sheets, feedback forms, and development plans that help you assess, plan, coach, measure progress, and adjust future training.',
  },
]

export const insideImages = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/f28YeELxZu2GunSKAvGzM5/Captura_de_pantalla_2026-09-13_a_la(s)_9.34.51_p._m..png',
    alt: 'Kitchen Pressure Game pressure-game page with court diagram, pressure metrics and coach observation notes',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/4L5BMcFzuC4qhLNP4THsep/Captura_de_pantalla_2026-09-13_a_la(s)_9.35.13_p._m..png',
    alt: 'Neutral to Offense tactical drill page with step-by-step flow, attack trigger, scoring and coaching cue',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/v7uiPJtRrDKpnE5aoGodTL/Captura_de_pantalla_2026-09-13_a_la(s)_9.35.35_p._m..png',
    alt: 'Speed-Up Recognition tactical drill page with ball height references, penalty rule and scoring',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/jt5mEv5vXmA2Y6NadnqYXb/Captura_de_pantalla_2026-09-13_a_la(s)_9.35.56_p._m..png',
    alt: 'Random Pressure Transition pressure drill page with feed types, coach observation and coaching cue',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/uUg8rjLGqG3pkRnYXuACW8/Captura_de_pantalla_2026-09-13_a_la(s)_9.36.23_p._m..png',
    alt: 'Dink Target Ladder dink drill page with three target levels, unlock rules and progression mechanics',
  },
]

export const bonuses = [
  {
    title: 'Match Analysis & Tactical Decision System™',
    description:
      'Professional match analysis, opponent scouting, tactical observation, and decision-making tools that turn competitive performance into clear training priorities.',
  },
  {
    title: 'Doubles Coaching Performance System™',
    description:
      'Practical resources for positioning, communication, coordinated movement, court coverage, attacking patterns, defensive recovery, and doubles decision-making.',
  },
  {
    title: 'Pickleball Clinic & Group Training Blueprint™',
    description:
      'Ready-to-use frameworks for clinics and groups using court rotations, stations, partner systems, skill circuits, and efficient training formats.',
  },
  {
    title: 'Competitive Player Preparation Toolkit™',
    description:
      'Tournament preparation, pressure scenarios, opponent analysis, match-day plans, tactical game plans, and post-competition evaluation tools.',
  },
  {
    title: 'Coaching Cues & Error Correction Playbook™',
    description:
      'Quick-reference tools for identifying technical and tactical problems and applying precise coaching cues, corrections, and targeted progressions.',
  },
]

export const benefits = [
  {
    emoji: '⚡',
    title: 'Stop Planning From Scratch',
    description:
      'Follow a complete coaching system instead of wasting hours searching for drills, organizing ideas, and rebuilding sessions every week.',
  },
  {
    emoji: '🏓',
    title: 'Coach With More Structure',
    description:
      'Access practical drills, progressions, sessions, programs, and tools you can apply directly on court.',
  },
  {
    emoji: '📈',
    title: 'Develop Players With A Clear Path',
    description:
      'Move players forward with structured progressions instead of disconnected drills and random sessions.',
  },
  {
    emoji: '🚀',
    title: 'Work Like A Professional',
    description:
      'Use assessments, planning systems, tracking tools, and coaching resources that make your sessions more organized and efficient.',
  },
]

export const testimonials = [
  {
    text: "I run six private lessons a day plus two evening clinics, and Sunday nights used to disappear into planning. I pulled three sessions straight out of the Ready-to-Coach library, ran them Monday, and my 3.0 players finally understood why we drill drops before drives. The progressions are the part I didn't know I was missing.",
    author: 'Greg Hollis, 52',
    role: 'PPR Certified Coach',
    location: 'Naples, Florida',
  },
  {
    text: "The Drill Library alone paid for this ten times over. Every drill has a setup, a coaching focus, and a regression, so when a group is struggling I can dial it back instantly instead of improvising. My clinics run smoother and I stopped losing beginners in the first twenty minutes.",
    author: 'Marisol Vega, 41',
    role: 'Club Pickleball Director',
    location: 'Scottsdale, Arizona',
  },
  {
    text: "I coach a lot of doubles teams and the Doubles Coaching Performance System changed how I teach positioning and communication. Instead of yelling 'shift!' from the sideline, I have patterns and cues my pairs can actually rehearse. Two of my teams medaled at their first tournament this spring.",
    author: 'Dan Whitaker, 47',
    role: 'Head Coach & Tournament Trainer',
    location: 'Charlotte, North Carolina',
  },
  {
    text: "What sold me was the Coach Toolkit. Player profiles, skill checklists, progress trackers — my students can finally see their kitchen control and reset consistency improving month over month. Parents and retirees both love seeing the numbers, and my retention has never been higher.",
    author: 'Karen Doyle, 58',
    role: 'Recreation Center Instructor',
    location: 'Boise, Idaho',
  },
  {
    text: "I switched from tennis coaching to pickleball two years ago and was rebuilding every lesson from scratch. The Session Planner gave me frameworks I trust, and the Development Programs let me map twelve weeks for a competitive player in one sitting. I coach with far more confidence now.",
    author: 'Tyrell Banks, 35',
    role: 'Private Pickleball Coach',
    location: 'Austin, Texas',
  },
]

export const faqs = [
  {
    question: 'Is this a physical product?',
    answer: 'No. It is a 100% digital product delivered instantly after purchase.',
  },
  {
    question: 'Is this suitable for experienced pickleball coaches?',
    answer:
      'Yes. The system is designed to provide practical, ready-to-use coaching material rather than basic theory, helping experienced coaches save planning time and organize player development.',
  },
  {
    question: 'Can I use the material directly on court?',
    answer:
      'Yes. PICKLEBALL COACH PRO™ includes ready-to-use drills, progressions, session structures, development programs, assessments, and professional coaching tools designed for practical application.',
  },
  {
    question: 'Can I use it with different player levels?',
    answer:
      'Yes. The system includes material that can be adapted for beginner, intermediate, and advanced players, as well as private lessons, groups, clinics, doubles teams, and competitive training.',
  },
  {
    question: 'Does it include complete sessions and programs?',
    answer:
      "Yes. You'll receive structured sessions you can take directly to the court, plus progressive development programs designed to organize training across multiple weeks.",
  },
  {
    question: 'Can I use it for private lessons and group coaching?',
    answer:
      'Yes. The planning systems, drills, sessions, and adaptations can be used across private coaching, pairs, small groups, clinics, and other common coaching environments.',
  },
  {
    question: 'How will I receive access?',
    answer: "Immediately after payment. You'll receive everything by email within minutes.",
  },
  {
    question: 'Can I print the drills, sessions, and coaching sheets?',
    answer:
      'Yes. Every drill card, session plan, assessment, checklist, and tracker is print-ready, so you can bring them straight to the court on a clipboard or keep them on your phone or tablet.',
  },
  {
    question: 'Do I need special equipment or a dedicated facility?',
    answer:
      'No. The drills and sessions are built around standard court setups and basic equipment such as balls, paddles, cones, and targets, and most activities include adaptations for limited court time or shared facilities.',
  },
  {
    question: 'Is this a one-time payment or a subscription?',
    answer:
      'It is a one-time payment of $27 USD. You receive the complete 6-in-1 system and all 5 premium bonuses, with no recurring fees and no upsells required to use the material.',
  },
]

export const purchases = [
  { name: 'Greg H.', location: 'Naples, Florida' },
  { name: 'Marisol V.', location: 'Scottsdale, Arizona' },
  { name: 'Dan W.', location: 'Charlotte, North Carolina' },
  { name: 'Karen D.', location: 'Boise, Idaho' },
  { name: 'Tyrell B.', location: 'Austin, Texas' },
  { name: 'Bill R.', location: 'Sarasota, Florida' },
  { name: 'Angela P.', location: 'Denver, Colorado' },
  { name: 'Steve M.', location: 'San Diego, California' },
]
